module.exports = __webpack_public_path__ + "img/lot_john_r_cars_filtered.fe9c6451.jpg";